import React from 'react';
import CoursesPage from '../component/CoursesPage';

function RegisterMentee() {
  return (
    <CoursesPage/>
  );
}

export default RegisterMentee;
